module.exports = __webpack_public_path__ + "9da6909c806614e6fc7f32c6ce95d4f5.png";